import axios from '../../router/axios';

const api = process.env.REACT_APP_API_URL;

export const fetchUser = (fetchUserData) => async (dispatch) => {
  try {
    const res = await axios.post(`${api}/admin/getUserList`,fetchUserData); 
    dispatch({ type: 'GET_USER_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'USER_FAIL', payload: error.response?.data?.message || 'Failed to fetch'});
  }
};

export const fetchSubscriptionPlanOption = () => async (dispatch) => {
  try {
    const res = await axios.get(`${api}/admin/getSubscriptionPlanOption`);
    dispatch({ type: 'GET_PRODUCT_SUCCESS', payload: res.data });
  } catch (error) {
    dispatch({ type: 'USER_FAIL', payload: error.response?.data?.message || 'Failed to fetch'});
  }
};

export const resendVisibilityApply = (productId) => async () => {
  const res = await axios.post(`${api}/admin/resendVisibilityApply`, { productId });
  return res;
};
